"use client";

import { c as _c } from "react/compiler-runtime";
import { useParams, useRouter } from "next/navigation";
import { useRouteStore } from "@/shared/stores/data/store";
import { Icon } from "@/shared/ui/atoms";
import { CustomButton } from "@/shared/ui/molecules";
import { useGetLocale } from "@/shared/hooks/useGetLocale";
const RankingHeader = () => {
  const $ = _c(16);
  const router = useRouter();
  const locale = useGetLocale();
  const pathParams = useParams();
  let t0;
  if ($[0] !== locale || $[1] !== pathParams?.locale || $[2] !== router) {
    t0 = () => {
      useRouteStore.getState().setIsGoingBack(true);
      const prev = useRouteStore.getState().popPath(locale);
      router.push(prev || `/${pathParams?.locale}`);
    };
    $[0] = locale;
    $[1] = pathParams?.locale;
    $[2] = router;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleBack = t0;
  let t1;
  if ($[4] !== locale || $[5] !== router) {
    t1 = () => {
      router.push(`/${locale}/search`);
    };
    $[4] = locale;
    $[5] = router;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleSearch = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon src="/icons/direction-black.svg" alt="back" width={24} />;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== handleBack) {
    t3 = <CustomButton onClick={handleBack} className="flex h-6 w-6 items-center justify-center">{t2}</CustomButton>;
    $[8] = handleBack;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon src="/icons/search.svg" alt="search" width={24} />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== handleSearch) {
    t5 = <CustomButton onClick={handleSearch} className="flex h-6 w-6 items-center justify-center">{t4}</CustomButton>;
    $[11] = handleSearch;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <div className="flex h-[54px] items-center justify-between bg-white px-4 py-[10px]">{t3}{t5}</div>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default RankingHeader;